import React from 'react';

import PageTitle from '../page-title/PageTitle';
import CategoriesCard from '../categories-card/CategoriesCard';

import { categories } from './categories-data';

import { CategoriesContainer } from './Categories.styles';

const Categories = () => {
  return (
    <div style={{ marginTop: '3rem' }}>
      <PageTitle>Categories</PageTitle>
      <CategoriesContainer>
        {categories.map(category => (
          <CategoriesCard key={category.id} details={category} />
        ))}
      </CategoriesContainer>
    </div>
  );
};

export default Categories;
